'use strict'

import { firebaseStore } from '@/libs/firebase'
import util from '@/libs/util'

const list = async (uid) => {
  const data = await firebaseStore.list('user', uid, 'project')
  const projects = data.map((doc) => {
    const project = util.getProject(doc)
    project.timeStamp = _.get(doc, 'date')
    project.date = util.dateOrHour(project.timeStamp)
    return project
  })
  return Promise.resolve(projects)
}

const get = async (uid, fileName) => {
  const data = await firebaseStore.get('user', uid, 'project', fileName)
  const project = util.getProject(data)
  return Promise.resolve(project)
}

const set = async (uid, fileName, data) => {
  const calData = util.getProjectData(data)
  return await firebaseStore.set('user', uid, 'project', fileName, calData)
}

const remove = async (uid, fileName) => {
  return await firebaseStore.remove('user', uid, 'project', fileName)
}

const removeAll = async (uid) => {
  await firebaseStore.remove('user', uid, 'current', 'group')
  await firebaseStore.remove('user', uid, 'current', 'project')
}

export default {
  list,
  get,
  set,
  remove,
  removeAll
}
